import React, {useContext, useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from '@mui/material';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import {Zoom} from '@mui/material';
import {Autocomplete} from '@mui/lab';
import {ticketTypes} from '../../../view/Landing/CustomerBookTicket/TicketModel';
import {settingAction, settingApi} from '../../../services/TicketsServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext} from '../../../store';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});

const initialValues = {
  key: '',
  value: null,
  museum_id: null
}

export default function SetFee({open, handleAction, settingId, museums, setMuseums}) {
  const [user, setUser] = useState({});
  const userId = user?.id;
  const dispatch = useContext(DispatchContext);
  const [initialValue, setInitialValue] = useState(initialValues);
  const [settings, setSettings] = useState([]);
  const [selectedMuseumId, setSelectedMuseumId] = useState(null);

  useEffect(() => {
    if (open && settingId) {
      settingAction('get', settingId, null, {per_page: 100}).then(res => {
        setInitialValue({
          ...res?.data
        })
      })
    }
  }, [open]);

  useEffect(() => {
    if (selectedMuseumId) {
      settingApi('get', userId, null, {per_page: 100}).then(res => {
        setSettings(res?.data)
      })
    }
  },[selectedMuseumId]);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const getSelectedMuseum = (museumId) => {
    return museums?.find(val => parseInt(val?.id) === parseInt(museumId)) || null;
  };

  const getSelectedType = (typeId) => {
    return ticketTypes?.find(val => val?.id === typeId) || null;
  };

  const getTicketList = () => {
    if (selectedMuseumId) {

      // Checking selected setting list under selected museum
      const selectedSettings =  settings.filter(setting => setting?.museum_id === selectedMuseumId);

      // Collecting the keys of selected settings
      const selectedKeys = selectedSettings.map(setting => setting.key);

      // Showing only ticketTypes that are not selected
      const availableTicketTypes = ticketTypes.filter(ticketType => !selectedKeys.includes(ticketType.id));

      return availableTicketTypes;
    }
    return ticketTypes
  }

  const onSubmit = (values) => {
    const updatedValues = {
      key: values?.key,
      value: values?.value
    }
    if (settingId) {
      settingAction('put', settingId, {...updatedValues}).then(res => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'Fees updated successfully'}
        });
        handleAction();
      })
    } else {
      settingApi('post', {...values}).then(res => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {isNotify: true, severity: 'success', message: 'Fees added successfully'}
        });
        handleAction();
      })
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleAction}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle>{settingId ? 'Update Museum Fees' : 'Set Museum Fees'}</DialogTitle>
      <Formik
        initialValues={initialValue}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({values, setFieldValue}) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item sm={12}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={museums}
                    value={getSelectedMuseum(values?.museum_id)}
                    getOptionLabel={(option) => (option?.name)}
                    size={'small'}
                    className="dob mr-2 mt-3"
                    onChange={(e, value) => {
                      setFieldValue('museum_id', value?.id || null);
                      setSelectedMuseumId(value?.id);
                    }}
                    renderInput={(params) => <Field component={TextField} {...params}
                                                    placeholder="Select museum"
                                                    label={
                                                      <div>
                                                        <span style={{color: 'red'}}>*</span>
                                                        Select Museum
                                                      </div>
                                                    }
                                                    InputLabelProps={{
                                                      style: {color: '#929191', fontSize: 14},
                                                      shrink: true
                                                    }}
                                                    name="museum_id"/>}
                  />
                </Grid>
                <Grid item sm={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={getTicketList()}
                    value={getSelectedType(values?.key)}
                    getOptionLabel={(option) => (option?.name)}
                    size={'small'}
                    className="dob mr-2 mt-3"
                    onChange={(e, value) => {
                      setFieldValue('key', value?.id || null);
                    }}
                    renderInput={(params) => <Field component={TextField} {...params}
                                                    placeholder="Select visitor type"
                                                    label={
                                                      <div>
                                                        <span style={{color: 'red'}}>*</span>
                                                        Visitor type
                                                      </div>
                                                    }
                                                    InputLabelProps={{
                                                      style: {color: '#929191', fontSize: 14},
                                                      shrink: true
                                                    }}
                                                    name="key"/>}
                  />
                </Grid>
                <Grid item sm={6}>
                  <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
                         label={
                           <div>
                             <span style={{color: 'red'}}>*</span>
                             Set Fee
                           </div>
                         }
                         name="value" type={'number'}
                         InputLabelProps={{
                           style: {fontSize: 14, color: '#929191'},
                           shrink: true
                         }}/>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAction} variant={'outlined'} color={'error'} className={'text-capitalize'}
                      sx={{width: 40, height: 30}}>cancel</Button>
              <Button variant={'contained'} type={'submit'} className={'text-capitalize'}
                      sx={{width: 40, height: 30}}>{settingId ? 'Update' :'Confirm'}</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};